export const generateSocialPost = (message, style) => {
  // Clean text and remove formatting
  let cleanText = message
    .replace(/#{1,6}\s+/g, '')
    .replace(/\*\*\*/g, '')
    .replace(/\*\*/g, '')
    .replace(/\*/g, '')
    .replace(/`{1,3}[^`]*`{1,3}/g, '')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
  
  // Split into sentences
  const sentences = cleanText.split(/(?<=[.!?])\s+/);
  
  // Filter out meta/conversational content - keep only the wisdom
  const meaningfulSentences = sentences.filter(sentence => {
    const lower = sentence.toLowerCase();
    // Skip conversational phrases
    if (lower.includes('thank you')) return false;
    if (lower.includes('let me')) return false;
    if (lower.includes('i understand')) return false;
    if (lower.includes('great question')) return false;
    // Skip meta descriptions about FHO-OS lens
    if (lower.includes('through the fho-os')) return false;
    if (lower.includes('fho-os lens')) return false;
    if (lower.includes('system operations')) return false;
    if (lower.includes('demonstrates')) return false;
    // Skip headers/titles
    if (sentence.includes('Through the FHO-OS')) return false;
    if (sentence.includes('NEXT STEPS')) return false;
    if (sentence.match(/^#+/)) return false;
    // Skip very short sentences (likely fragments)
    if (sentence.trim().length < 40) return false;
    // Keep biblical/wisdom content
    return true;
  });
  
  // Get the powerful content (skip first few if they're still meta)
  let contentSentences = meaningfulSentences;
  
  // Additional check: skip first sentence if it's still intro-like
  if (contentSentences.length > 2) {
    const first = contentSentences[0].toLowerCase();
    if (first.includes('was one of') || first.includes('likely from') || 
        first.includes('demonstrates') || first.includes('key system')) {
      contentSentences = contentSentences.slice(1);
    }
  }
  
  // Take first 3-4 meaningful sentences
  let excerpt = contentSentences.slice(0, 4).join(' ');
  
  // Limit to 350 chars
  if (excerpt.length > 350) {
    excerpt = excerpt.substring(0, 350);
    const lastPeriod = excerpt.lastIndexOf('.');
    const lastQuestion = excerpt.lastIndexOf('?');
    const lastExclaim = excerpt.lastIndexOf('!');
    const lastPunctuation = Math.max(lastPeriod, lastQuestion, lastExclaim);
    
    if (lastPunctuation > 150) {
      excerpt = excerpt.substring(0, lastPunctuation + 1);
    } else {
      excerpt = excerpt + '...';
    }
  }
  
  // If we filtered too much and have no content, take the middle section
  if (!excerpt || excerpt.length < 50) {
    const middle = sentences.slice(Math.floor(sentences.length / 3), Math.floor(sentences.length / 3) + 3);
    excerpt = middle.join(' ').substring(0, 350);
  }
  
  const hashtags = '\n\n#EmittheBible #FHO #EmitServes';
  
  const templates = {
    insight: `💡 Biblical Insight:\n\n${excerpt}${hashtags}`,
    gratitude: `🙏 Grateful for this truth:\n\n${excerpt}${hashtags}`,
    transformation: `✨ Transformation moment:\n\n${excerpt}${hashtags}`,
    encouragement: `💪 For anyone who needs this:\n\n${excerpt}${hashtags}`
  };
  
  return templates[style] || templates.insight;
};

export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return { success: true };
  } catch (err) {
    return { success: false, error: err };
  }
};
